import { useState, useEffect } from 'react';

const DEFAULT_THEME = 'flannel';
const POLL_INTERVAL_MS = 5000;

export default function useOverlayTheme(channelName) {
  const [theme, setTheme] = useState(DEFAULT_THEME);

  useEffect(() => {
    let cancelled = false;

    const fetchTheme = async () => {
      try {
        const response = await fetch(
          `/api/admin?action=get-overlay-theme-public&channel=${encodeURIComponent(channelName)}`
        );
        if (!cancelled && response.ok) {
          const data = await response.json();
          if (data.success && data.theme) {
            setTheme(data.theme);
          }
        }
      } catch (err) {
        console.error('Error fetching overlay theme:', err);
      }
    };

    fetchTheme();
    const interval = setInterval(fetchTheme, POLL_INTERVAL_MS);

    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, [channelName]);

  return { theme };
}
